export { default as getTextDimension } from './getTextDimension';
export { default as getMultipleTextDimensions } from './getMultipleTextDimensions';
export { default as computeMaxFontSize } from './computeMaxFontSize';
export { default as computeInnerDimension } from './computeInnerDimension';
export { mergeMargin, mergePadding } from './mergeMargin';
export { default as parseLength } from './parseLength';
export const EMPTY_MARGIN = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
export const EMPTY_PADDING = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
export * from './types';